import { DataBean } from "../DataBean";

export class ExportationsSupport extends DataBean {


    public async getExportationsSupportCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getExportationsSupportCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

}